<div class="jit-progress-bar">
  <div class="jit-progress-bar__percentage" [ngStyle]="{'width.%': percentage}"></div>
</div>